export interface BulkShareShipment {
  id: string;
  reference_number?: string | null;
}

/** The same external-view URL the single-shipment share copies. */
export const buildShareLink = (
  baseUrl: string,
  shipmentId: string,
  token: string
): string => `${baseUrl}share/shipment/external-view/${shipmentId}/${token}`;

/** `[Reference ID]: [link]`, with a dash where the shipment has no reference. */
export const formatTrackingLinkLine = (
  referenceNumber: string | null | undefined,
  link: string
): string => `${referenceNumber?.trim() || '-'}: ${link}`;

/** One shipment per line, in the order given. */
export const formatTrackingLinkLines = (
  entries: { referenceNumber?: string | null; link: string }[]
): string =>
  entries
    .map(({ referenceNumber, link }) =>
      formatTrackingLinkLine(referenceNumber, link)
    )
    .join('\n');

/**
 * Runs `task` over `items` with at most `limit` in flight, so a large
 * selection does not fire every share request at once.
 */
export const mapWithConcurrency = async <T, R>(
  items: T[],
  limit: number,
  task: (item: T) => Promise<R>
): Promise<R[]> => {
  const results: R[] = new Array(items.length);
  let next = 0;
  const worker = async (): Promise<void> => {
    while (next < items.length) {
      const index = next;
      next += 1;
      results[index] = await task(items[index]);
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, () => worker())
  );
  return results;
};
